import React from 'react';
import { Section } from '../../../../entities/v1/survey_engine/Section';
import { Col } from 'reactstrap';
import { Question } from '../../../../entities/v1/survey_engine/Question';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { HorizontalDivider } from '../../../HorizontallDivider';

interface PropTypes {
  section: Section;
  showFieldLabels?: boolean;
  preview?: boolean;
}

export function OpenTextSection(props: PropTypes) {
  return (
    <>
      <div className='fw-semibold fs-3 mb-4'>{props.section.name}</div>
      {props.section.questions.map((question: Question, index: number) => (
        <Col xs='12' className='align-items-stretch' key={question.id}>
          <div
            className={classNames(
              'd-flex fs-5 fw-semibold text-primary-dark justify-content-between',
              {
                'mb-3':
                  index !== props.section.questions.length - 1 &&
                  !props.preview,
              },
            )}
          >
            {props.preview && props.showFieldLabels ? (
              <div className='text-dark-500'>Open Text Area</div>
            ) : (
              question.title
            )}
          </div>

          {index !== props.section.questions.length - 1 && !props.preview ? (
            <HorizontalDivider classNames='mb-3' />
          ) : null}
          {props.preview && (
            <div
              className={classNames(
                styles['text-field'],
                'rounded-2 flex-fill fs-5 text-dark-200 pt-2 px-2h bg-gray',
              )}
            >
              Insert response here
            </div>
          )}
        </Col>
      ))}
    </>
  );
}
